import { useEffect, useState } from "react"

import { Script } from "gatsby"

import readCookie from "../../utils/read-cookie"
import readSubcookie from "../../utils/read-subcookie"

export const getConsentValues = () => {
  const oneTrustCookie = readCookie("OptanonConsent")
  const consentMap = {}
  if (oneTrustCookie) {
    const groups = readSubcookie(oneTrustCookie, "groups") ?? ""
    groups.split(",").forEach((group) => {
      const tuple = group.split(":")
      consentMap[tuple[0]] = tuple[1] === "1"
    })

    return consentMap
  }
  return undefined
}

const Driftt = () => {
  const [triggerdConsentValues, setTriggerdConsentValue] = useState(false)
  const [consentValues, setConsentValue] = useState(getConsentValues())
  const consentCookiePresent = readCookie("OptanonConsent")

  const driftFunction = (
    <Script type="text/javascript">
      {`
      "use strict";

      function loadDriftWidget() {
        var t = window.driftt = window.drift = window.driftt || [];
        if (!t.init) {
          if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
          t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ],
            t.factory = function(e) {
              return function() {
                var n = Array.prototype.slice.call(arguments);
                return n.unshift(e), t.push(n), t;
              };
            }, t.methods.forEach(function(e) {
              t[e] = t.factory(e);
            }), t.load = function(t) {
              var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
              o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
              var i = document.getElementsByTagName("script")[0];
              i.parentNode.insertBefore(o, i);
            };
        }
        drift.SNIPPET_VERSION = '0.3.1';
        drift.load('x2ugb2nh7dxy');
        var random = Math.floor(Math.random() * (100 - 1)) + 1;
        if( random <= 50 ) {
          document.cookie = "DriftPlaybook=A";
        } 
        else {
          document.cookie = "DriftPlaybook=B";
        }
      };
      loadDriftWidget();
      `}
    </Script>
  )
  useEffect(() => {
    // Added an event listener provided by OneTrust called 'consent.onetrust' that checks if the user toggeled on the 'funcs' cookie
    window.addEventListener("consent.onetrust", (e) => {
      if ("detail" in e && Array.isArray(e.detail) && e.detail.includes("funcs")) {
        setTriggerdConsentValue(!triggerdConsentValues)
        setConsentValue(getConsentValues())
      }
    })
  }, [triggerdConsentValues])

  // If the 'OptanonConsent' cookie exist and the 'func' permission is true (the user permitted the functionality cookie) => we load drift
  if (consentCookiePresent && consentValues?.funcs) {
    return driftFunction
  }
  return null
}
export default Driftt

export const assignRandomDriftPlaybook = () => {
  function getRandomInt(min, max) {
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min)) + min
  }

  var random = getRandomInt(1, 100)

  if (random <= 50) {
    document.cookie = "DriftPlaybook=A"
  } else {
    document.cookie = "DriftPlaybook=B"
  }
}
